export default "__VITE_ASSET__45d99252__"